"use client";
import * as React from "react";
const SvgSuccessSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M6.4 12l-4-4 1.13-1.13L6.4 9.74l6.07-6.08L13.6 4.8z" }));
export {
  SvgSuccessSharp as default
};
